import "@legacy/entrypoints/product-carousel";
import "@legacy/entrypoints/product-card";
import "@legacy/entrypoints/cart";

import {
    getQuantityAttributes,
    stopCartRequests,
    resetCartRequests,
} from "@legacy/modules/cart.module";
import eventBus from "@legacy/modules/event-bus.module";

try {
    const actionsBlocks = document.querySelectorAll("[data-product-actions]");

    actionsBlocks.forEach((actionsBlock) => {
        const btnBuyNow = actionsBlock.querySelector<HTMLButtonElement>("[data-buy-now-btn]");
        const quantityInput = actionsBlock.querySelector<HTMLInputElement>("[data-quantity-input]");

        // Если в корзине нет данного товара, то добавить 1
        // Перейти на страницу корзины
        btnBuyNow?.addEventListener("click", async () => {
            btnBuyNow.disabled = true;
            await stopCartRequests();
            const quantity =
                parseInt(quantityInput?.dataset.quantity ?? "") || 0;
            if (quantity === 0) {
                await resetCartRequests();
                const { setQuantity } = getQuantityAttributes(btnBuyNow);
                setQuantity(1);
                await stopCartRequests();
            }
            location.href = "/cart";
        });
    });

    // @ts-ignore
    eventBus.subscribe("cart-changed", ({ variantId, quantity }) => {
        actionsBlocks.forEach((actionBlock) => {
            const addToCartButton = actionBlock.querySelector(
                `[data-add-to-cart-btn][data-variant-id="${variantId}"]`,
            );
            const buyNowButton = actionBlock.querySelector(
                `[data-buy-now-btn][data-variant-id="${variantId}"]`,
            );
            const goToCartButton = actionBlock.querySelector(
                `[data-go-to-cart][data-variant-id="${variantId}"]`,
            );
            const counter = actionBlock.querySelector(
                `[data-counter][data-variant-id="${variantId}"]`,
            );

            if (quantity > 0) {
                addToCartButton?.classList.add("display-none");
                buyNowButton?.classList.add("display-none");
                counter?.classList.remove("display-none");
                goToCartButton?.classList.remove("display-none");
            } else {
                addToCartButton?.classList.remove("display-none");
                buyNowButton?.classList.remove("display-none");
                counter?.classList.add("display-none");
                goToCartButton?.classList.add("display-none");
            }
        });
    });
} catch (error) {
    console.error(error);
}

//#region Description
try {
    const description = document.querySelector<HTMLElement>("#description")!;
    const content = description.querySelector<HTMLElement>("[data-content]")!;
    const btnMore = description.querySelector<HTMLElement>("[data-btn-more]")!;
    const btnLess = description.querySelector<HTMLElement>("[data-btn-less]")!;

    // Раскрыть описание
    btnMore.addEventListener("click", () => {
        description.dataset.expanded = "true";
    });

    // Свернуть описание
    btnLess.addEventListener("click", () => {
        description.dataset.expanded = "false";
        updateBtnMoreVisibility();
    });

    new ResizeObserver(updateBtnMoreVisibility).observe(content);

    // Когда описание не раскрыто, но весь текст влезает, не показывать кнопку view more
    // и не накладывать маску прозрачности на текст
    function updateBtnMoreVisibility() {
        if (description.dataset.expanded === "false" && content.scrollHeight > content.clientHeight) {
            description.dataset.overflow = "true";
        } else {
            description.dataset.overflow = "false";
        }
    }
} catch (error) {
    console.error(error);
}
//#endregion
